<template>
<div>
    <bar-manut 
        single-entity="Categoria Marketplace" 
        plural-entity="Categorias Marketplace"
        :crud="this.crud" 
        :btn-delete="false"
        @closeform="closeForm" 
        @delete="handleDelete" 
        @save="handleSave">
    </bar-manut>
    <div>
        <div class="default-container">
            <div class="row">
                <form-field v-model="catmkt.codcatmkt" :metadata="metadata.catmkt.codcatmkt" type="text" col="2" :disabled="true"></form-field>
                <div class="col mt-2 mb-5">
                    <input-checkbox v-model="catmkt.stcatmkt" value-checked="A" value-unchecked="I" label="Categoria Ativa" ></input-checkbox>
                </div>
            </div>
                
                
            <div class="row">
                <form-field ref="altern" v-model="catmkt.altern" type="text" col="4" :metadata="metadata.catmkt.altern" 
                    name="altern" :v-errors="errors" v-validate="metadata.catmkt.altern.validator"></form-field>
            </div>                    
            <div class="row">
                <form-field ref="nome" v-model="catmkt.nome" type="text" col="8" :metadata="metadata.catmkt.nome" 
                    name="nome" :v-errors="errors" v-validate="metadata.catmkt.nome.validator"></form-field>
            </div>                    
            <div class="row">
                <form-field ref="marketplacecatmkt" v-model="catmkt.marketplacecatmkt" type="select" col="4" :metadata="metadata.catmkt.marketplacecatmkt"
                    name="marketplacecatmkt" :v-errors="errors" v-validate="metadata.catmkt.marketplacecatmkt.validator"></form-field>

            </div>
        </div>
    </div>
</div>

</template>

<script>

import { SysVars } from '../main'
import { apiORDSpost, apiORDSdelete } from '../shared/api-functions'

export default {
    props: {
        index: '',
        crud: '',
    },

    data() {
        return {
            crudText: '',
            catmkt: {...this.$store.getters.getEntities.catmkt},
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [],  //armazena as mensagens de validacao do servidor para mostrar em tela
        }
    },

    computed: {
        editing: function () {
            return this.crud == SysVars.crudU
        }

    },

    methods: {
        closeForm () {
            this.$emit('closeform', this.catmkt.codcatmkt)
        },

        handleSave () {
            //BOTAO SALVAR
            this.$validator.validateAll().then(isValid => {
                if (!isValid) {
                    this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
                } else {
                    this.apiPost()
                }
            })
        },

        handleDelete () {
            //BOTAO Excluir
            this.apiDelete()
        },

        async loadData () {
            //carrega o registro para alteracao ou visualizacao
            await this.$store.dispatch('loadCatmkt', { id: this.index } )                        
            if (this.$store.getters.getCatmkt) {
                this.catmkt = {...this.$store.getters.getCatmkt}                
            }  
            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip()
            })
            
        },

        async apiDelete () {
            //efetua a exclusao
            var modulo = 'cg/catmkt/' + this.catmkt.codcatmkt

            const data = await apiORDSdelete(this.$store, modulo)
            this.$erpToastDeleted()
            this.closeForm()
        },

        async apiPost () {
            //efetua a gravacao

            var modulo = 'cg/catmkt/'
            var sendData = {}

            sendData = { catmkt: this.catmkt }

            let metodo = 'post'
            let update = false
            if (this.crud != SysVars.crudI) {
                update = true
            }

            const data = await apiORDSpost(this.$store, modulo, sendData, metodo)
            if (data.errmessages) {
              this.errmessages = data.errmessages
              this.$erpToastError('Alguns erros precisam ser corrigidos.')
            } else {
                if (update) {
                    this.$erpToastUpdated()
                } else {
                    this.$erpToastInserted()
                }
                this.errmessages = {}
                this.closeForm()
            }
        },
        
    },

    components: {

    },

    beforeCreate () {

    },

    created () {
        
        this.crudText = this.$crudText(this.crud)

        if (this.crud == SysVars.crudI) {
            this.catmkt.stcatmkt = 'A'
        } else {
            this.loadData()  
        }
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip()
            this.$refs.altern.focus()
        })        
    }

}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/forms/catmkt-form.vue